/** Build a smooth diagonal gradient from a single base hex color. */
export const buildGradientFromColor = (hex: string): string => {
    const m = hex.replace('#', '').match(/^([0-9a-f]{6})$/i);
    if (!m) return `linear-gradient(135deg, ${hex} 0%, ${hex} 100%)`;
    const r = parseInt(m[1].slice(0, 2), 16);
    const g = parseInt(m[1].slice(2, 4), 16);
    const b = parseInt(m[1].slice(4, 6), 16);
    const lighten = (c: number, amt: number) =>
        Math.max(0, Math.min(255, Math.round(c + (255 - c) * amt)));
    const darken = (c: number, amt: number) =>
        Math.max(0, Math.min(255, Math.round(c * (1 - amt))));
    const toHex = (n: number) => n.toString(16).padStart(2, '0');
    const light = `#${toHex(lighten(r, 0.05))}${toHex(lighten(g, 0.05))}${toHex(lighten(b, 0.05))}`;
    const dark = `#${toHex(darken(r, 0.6))}${toHex(darken(g, 0.6))}${toHex(darken(b, 0.6))}`;
    return `linear-gradient(135deg, ${light} 0%, ${dark} 100%)`;
};

/** Curated palette of brand-friendly base colors. */
export const COLOR_PALETTE = [
    '#0DD3C3',
    '#49a09d',
    '#26d0ce',
    '#00f2fe',
    '#4facfe',
    '#a6c1ee',
    '#16213A',
    '#667eea',
    '#1a2980',
    '#9B6CFC',
    '#764ba2',
    '#5f2c82',
    '#f093fb',
    '#fbc2eb',
    '#ff7eb3',
    '#fa709a',
    '#ff758c',
    '#f5576c',
    '#eb3349',
    '#FF9A8B',
    '#f45c43',
    '#f7971e',
    '#ffd200',
    '#fee140',
    '#a8e063',
    '#56ab2f',
    '#43e97b',
    '#38ef7d',
    '#38f9d7',
    '#11998e',
];
